import { AxiosInstance, AxiosResponse } from 'axios'
import { EnumTypes, EarlyAnswerStrategy } from '../types/index.js'

export default class EnumsAPI {
  public _client: AxiosInstance

  constructor(axios: AxiosInstance) {
    this._client = axios
  }

  public async get(type: EnumTypes): Promise<Array<string>> {
    const result: AxiosResponse = await this._client.get(`enums/${type}`)

    return result.data.data.map((enm: any) => enm.id)
  }

  public async getEarlyAnswerStrategies(): Promise<Array<EarlyAnswerStrategy>> {
    const result: AxiosResponse = await this._client.get(
      'enums/earlyAnswerStrategies',
    )

    return result.data.data
  }
}
